import { Spinner } from 'react-bootstrap';

export default function Loader() {
    return (
        <div style={{ marginTop : '60px', textAlign: 'center' }}>
            <Spinner animation="border" role="status" />
        </div>
    )
}
